import * as React from 'react';

export class Summary extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            
        };
    }

    render() {
        return (
            <></>
        );
    }
}